<nz-card nzBorderless [nzTitle]="title">
  <ng-content></ng-content>
</nz-card>
